<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.provider_maintenance") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-retweet"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getProviderMaintenanceList()"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.category')") {{ $t('ui.category') }}
                        th(width="8%")
                          span(:title="$t('ui.aggregator')") {{ $t('ui.aggregator') }}
                        th(width="8%")
                          span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                        th(width="8%")
                          span(:title="$t('ui.provider_name')") {{ $t("ui.provider_name") }}
                        th(width="8%")
                          span(:title="$t('ui.start_date')") {{ $t("ui.start_date") }}
                        th(width="8%")
                          span(:title="$t('ui.end_date')") {{ $t("ui.end_date") }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                        th.text-center(width="7%")
                          span(:title="$t('ui.status')") {{ $t("ui.status") }}
                        th.text-center(width="5%" v-if="isAdminMaster && isEditAccess")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="maintList.length == 0")
                        td(:colspan="isAdminMaster && isEditAccess ? '9' : '8'").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in maintList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.category") {{ item.category }}
                        td
                          span(:title="item.aggregator") {{ item.aggregator }}
                        td
                          span(:title="item.provider_code") {{ item.provider_code }}
                        td
                          span(:title="item.provider_name") {{ item.provider_name }}
                        td
                          span(:title="item.start_date ? $moment(item.start_date).format('YYYY-MM-DD, HH:mm:ss') : item.start_date") {{ item.start_date ? $moment(item.start_date).format('YYYY-MM-DD, HH:mm:ss') : item.start_date }}
                        td
                          span(:title="item.end_date ? $moment(item.end_date).format('YYYY-MM-DD, HH:mm:ss') : item.end_date") {{ item.end_date ? $moment(item.end_date).format('YYYY-MM-DD, HH:mm:ss') : item.end_date }}
                        td.text-right
                          span(:title="item.modified_by") {{ item.modified_by ? item.modified_by : "-" }}
                          br
                          span(:title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ item.modified_date ? $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') : "-" }}
                        td.text-center
                          div.d-flex.justify-content-center.align-items-center
                            label.custom-switch
                              input.custom-switch-input.position-relative(type='checkbox' disabled name='custom-switch-checkbox' :disabled="!isAdminMaster || !isEditAccess" v-model="item.status" @change="changedStatus(item, $event)")
                              span.custom-switch-indicator
                        td.actions.text-center(v-if="isAdminMaster && isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(href="javascript:void(0)" @click="onUpdate(item)" :title="$t('ui.update')")
                          span
                            a.fa.fa-eraser.btn.btn-ssm.btn-icon.btn-danger(href="javascript:void(0)" @click="onClear(item)" :title="$t('ui.clear')")

      updatemaintenanceschedule(ref="updatemaintenanceschedule" :item="editSelectedProvider" @clicked="afterUpdate" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import updatemaintenanceschedule from "@/components/globalsetting/updateMaintenanceSchedule.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    updatemaintenanceschedule,
  },
  data: () => ({
    loading: false,
    maintList: [],
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedProvider: null,
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_providermaintenance");
    }
  },
  mounted: function() {
    this.getProviderMaintenanceList();
  },
  methods: {
    changedStatus: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_provider_status_confirm", { provider: item.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmStatus(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.status;
            item.status = !item.status;
          }
        });
    },
    confirmStatus: function(item, status) {
      let url = config.providerMaintenanceGlobalStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        provider_code: item.provider_code,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getProviderMaintenanceList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onClear: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.clear_maintenance_time_confirm", { name: item.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmClear(item);
          }
        });
    },
    confirmClear: function(item, isUp) {
      let url = config.providerMaintenanceGlobalUnsetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        provider_code: item.provider_code,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // item.status = status;
                this.getProviderMaintenanceList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onUpdate(e) {
      this.editSelectedProvider = e;
      this.$refs.updatemaintenanceschedule.$refs.updateMaintenanceSchedule.show();
    },
    afterUpdate: function(item) {
      this.getProviderMaintenanceList();
      this.$helpers.showDialog(this.$t("ui.combine.update_maintenance_schedule"), this.$t("message.success"), "success");
    },
    getProviderMaintenanceList: function() {
      let url = config.providerMaintenanceGlobalListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.maintList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>